import { useState } from 'react';
import { comments } from '@/mocks/data';

interface CommentSectionProps {
  articleId: number;
}

export default function CommentSection({ articleId }: CommentSectionProps) {
  const [commentIndex, setCommentIndex] = useState(0);
  const [newComment, setNewComment] = useState('');

  const currentComment = comments[commentIndex % comments.length];

  const handlePrevComment = () => {
    setCommentIndex((prev) => (prev - 1 + comments.length) % comments.length);
  };

  const handleNextComment = () => {
    setCommentIndex((prev) => (prev + 1) % comments.length);
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        {/* Section Title */}
        <div className="flex items-center gap-3 mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            网友神评
          </h2>
          <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
            {comments.length}条热评
          </span>
        </div>

        {/* Hot Comment Highlight */}
        <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 mb-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium mb-5">
            <i className="ri-fire-line text-accent-500"></i>
            炸裂指数 5.0
          </div>

          <blockquote className="font-heading text-foreground-800 text-base md:text-lg leading-relaxed italic mb-5">
            &ldquo;{currentComment.content}&rdquo;
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center overflow-hidden">
                <i className="ri-user-smile-line text-foreground-500 text-lg"></i>
              </div>
              <div>
                <p className="text-foreground-900 font-medium text-sm">{currentComment.userName}</p>
                <p className="text-foreground-500 text-xs">
                  #{currentComment.floor}楼 · {currentComment.likes.toLocaleString()} 赞 · {currentComment.time}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button onClick={handlePrevComment} className="w-9 h-9 rounded-lg border border-foreground-300 flex items-center justify-center text-foreground-500 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 cursor-pointer">
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button onClick={handleNextComment} className="w-9 h-9 rounded-lg bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all duration-200 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Comment Input */}
        <div className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <i className="ri-user-3-line text-foreground-400 text-lg"></i>
            </div>
            <div className="flex-1">
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value.slice(0, 500))}
                placeholder="发表你的神评论..."
                rows={3}
                className="w-full bg-background-50 border border-background-200/70 rounded-xl p-3 text-sm text-foreground-800 outline-none focus:border-primary-300 resize-none transition-colors placeholder:text-foreground-400"
              />
              <div className="flex items-center justify-between mt-2">
                <span className="text-foreground-400 text-xs">{newComment.length}/500</span>
                <button className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  发布评论
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}